import { Component } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'dido-spinner-renderer',
    templateUrl: './spinner-renderer.html',
    imports: [MatTooltip]
})
export class SpinnerRenderer implements ICellRendererAngularComp {
    params: any;

    agInit(params: any): void {
        this.params = params;
    }

    refresh(params: any): boolean {
        return false;
    }
}
